module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-wc-a86c202c.svg";